import React from 'react';
import { HeroBanner } from '../components/HeroBanner';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
export function ContactPage() {
  return <div className="flex flex-col w-full" data-id="element-261" data-mp="nxg7h5kmdgxc">
      <HeroBanner title="CONTACT US" subtitle="We're here to answer your questions and help protect your home." data-id="element-262" data-mp="spzmm6yygk49" />

      <section className="py-20 px-4 bg-white" data-id="element-263" data-mp="xoucfsvcb8xv">
        <div className="max-w-7xl mx-auto" data-id="element-264" data-mp="zd4164z38sh">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-265" data-mp="10o5v0euy6gy">
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 flex flex-col items-center text-center" data-id="element-266" data-mp="51gdxqbzu5bn">
              <div className="w-12 h-12 bg-[#0c2340] rounded-full flex items-center justify-center mb-4" data-id="element-267" data-mp="9yglk5ohrg4v">
                <Phone className="w-5 h-5 text-white" data-id="element-268" data-mp="ewrw6imm1uo5" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-269" data-mp="1leezonyj0scy">Phone</h3>
              <a href="tel:7146023634" className="text-[#b87333] hover:text-[#0c2340] transition-colors font-medium" data-id="element-270" data-mp="1qd8f4lxditfr">
                (714) 602-3634
              </a>
            </div>

            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 flex flex-col items-center text-center" data-id="element-271" data-mp="mzl528bd3p1c">
              <div className="w-12 h-12 bg-[#0c2340] rounded-full flex items-center justify-center mb-4" data-id="element-272" data-mp="i2369ar26q72">
                <Mail className="w-5 h-5 text-white" data-id="element-273" data-mp="d39qfboaun3q" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-274" data-mp="833w1nqnamhy">Email</h3>
              <a href="mailto:info@aflowraingutters.com" className="text-[#b87333] hover:text-[#0c2340] transition-colors font-medium" data-id="element-275" data-mp="3a1cm8fl0tfh">
                info@aflowraingutters.com
              </a>
            </div>

            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 flex flex-col items-center text-center" data-id="element-276" data-mp="3lgpezqj8z2hg">
              <div className="w-12 h-12 bg-[#0c2340] rounded-full flex items-center justify-center mb-4" data-id="element-277" data-mp="3gh46opi6ths2">
                <MapPin className="w-5 h-5 text-white" data-id="element-278" data-mp="36tqpi13yai5d" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-279" data-mp="3bstlkw1yde17">Service Area</h3>
              <p className="text-slate-600" data-id="element-280" data-mp="3br0fbhv94vtq">
                Orange County, CA &<br data-id="element-281" data-mp="2xun58tt1rwpa" />
                Surrounding Areas
              </p>
            </div>

            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 flex flex-col items-center text-center" data-id="element-282" data-mp="31vymoc1rpbme">
              <div className="w-12 h-12 bg-[#0c2340] rounded-full flex items-center justify-center mb-4" data-id="element-283" data-mp="3pl9sw91vzy7x">
                <Clock className="w-5 h-5 text-white" data-id="element-284" data-mp="3uit93ei5al2i" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-285" data-mp="3greo524og9st">Hours</h3>
              <p className="text-slate-600" data-id="element-286" data-mp="3kt9kds7r3wzq">
                Mon-Fri: 8am - 5pm
                <br data-id="element-287" data-mp="cdzpp566xu1z" />
                Sat-Sun: Closed
              </p>
            </div>
          </div>

          <div className="max-w-3xl mx-auto bg-slate-50 rounded-2xl border border-slate-200 p-8 sm:p-10" data-id="element-288" data-mp="h4g2cn26tbna">
            <h2 className="text-2xl font-bold text-[#0c2340] mb-2 text-center" data-id="element-289" data-mp="21ulgr2yf7kj9">
              Send Us a Message
            </h2>
            <p className="text-slate-500 text-center mb-8" data-id="element-290" data-mp="1wv8v2ljacji9">
              Have a general question? Fill out the form below.
            </p>

            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-291" data-mp="2bmr7yagulxxe">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-292" data-mp="26mlmjc1697nr">
                <div className="space-y-2" data-id="element-293" data-mp="1ixagpg4ysn2r">
                  <label htmlFor="name" className="block text-sm font-medium text-slate-700" data-id="element-294" data-mp="1iy2f0ypy4ywq">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="John Doe" data-id="element-295" data-mp="1nvc0k3a7sqfa" />
                </div>
                <div className="space-y-2" data-id="element-296" data-mp="18uf6mgfyrrig">
                  <label htmlFor="email" className="block text-sm font-medium text-slate-700" data-id="element-297" data-mp="18vqbkjl5b5b5">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="john@example.com" data-id="element-298" data-mp="1mt56g3u645ai" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-299" data-mp="21iuhqrvz5poi">
                <label htmlFor="subject" className="block text-sm font-medium text-slate-700" data-id="element-300" data-mp="25k62aizzrkpu">
                  Subject
                </label>
                <input type="text" id="subject" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="How can we help?" data-id="element-301" data-mp="2fhaq0n9hjo8r" />
              </div>

              <div className="space-y-2" data-id="element-302" data-mp="2fo38eixz5jqp">
                <label htmlFor="message" className="block text-sm font-medium text-slate-700" data-id="element-303" data-mp="2blzn72li70s8">
                  Message
                </label>
                <textarea id="message" rows={5} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow resize-none" placeholder="Your message..." data-id="element-304" data-mp="33d5mxhxbawgz"></textarea>
              </div>

              <button type="submit" className="w-full bg-[#b87333] hover:bg-[#a0632a] text-white font-bold py-4 px-8 rounded-lg transition-colors" data-id="element-305" data-mp="3r41ce8eapfl2">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>;
}